module.exports = __webpack_public_path__ + "static/media/Podiatry.b0ec2119.svg";